import { FeaturesState } from '@core/features/store/state/features.state';

export const featuresState = [FeaturesState];
